module.exports = __webpack_public_path__ + "static/kitchen-a2ff8fbea0053584dd6db73bb58f88db.jpg";